// All content & assets for the ISIC-UTCB landing page (1:1 replica)

export const APP_LINKS = {
  appStore:
    "https://apps.apple.com/us/app/alive-app/id1550658938?utm_source=aliveapp.net&utm_medium=referral",
  googlePlay:
    "https://play.google.com/store/apps/details?id=com.bootiq2.gtsisic&referrer=utm_source%3Daliveapp.net%26utm_medium%3Dreferral%26anid%3Dadmob",
  revalidate: "https://aplica.isic.ro/?issuer_id=109516",
  moreRomania:
    "https://www.isic.ro/reduceri/local/?dmLimit=10&dmSortKey=views&dmSortOrder=desc&dmSeed=3100&dmDisplay=images",
  moreInternational: "https://www.isic.org/discounts/",
};

export const ROMANIA_DISCOUNTS = [
  { logo: "/assets/logo-penny.webp", label: "10% reducere", link: "https://www.isic.ro/reduceri/ro/penny/9679", alt: "Penny" },
  { logo: "/assets/logo-starbucks.png", label: "20% reducere la băuturi și gustări", link: "https://www.isic.ro/reduceri/ro/starbucks/10799", alt: "Starbucks", logoScale: 1.15 },
  { logo: "/assets/logo-ikea.png", label: "10% reducere la cardurile cadou", link: "https://www.isic.ro/reduceri/ro/ikea/6994", alt: "IKEA" },
  { logo: "/assets/logo-spotify.webp", label: "Ofertă specială pentru studenți", link: "https://www.isic.ro/reduceri/ro/spotify/9056", alt: "Spotify" },
  { logo: "/assets/logo-sephora.webp", label: "20% reducere la Sephora Collection", link: "https://www.isic.ro/reduceri/ro/sephora/10161", alt: "Sephora" },
  { logo: "/assets/logo-christian-tour.png", label: "Travel Prime gratuit, în loc de 79€ pe an", link: "https://www.isic.ro/reduceri/ro/christian-tour/10378", alt: "Christian Tour" },
  { logo: "/assets/logo-carrefour.webp", label: "7% reducere", link: "https://www.isic.ro/reduceri/ro/carrefour/7921", alt: "Carrefour" },
  { logo: "/assets/logo-burger-king.png", label: "15% reducere", link: "https://www.isic.ro/reduceri/ro/burger-king/6921", alt: "Burger King" },
  { logo: "/assets/logo-worldclass.png", label: "până la 40€ reducere la abonamente", link: "https://www.isic.ro/reduceri/ro/world-class/3579", alt: "World Class" },
];

export const INTERNATIONAL_DISCOUNTS = [
  { img: "/assets/intl-wall.png", alt: "Berlin - The Wall Museum" },
  { img: "/assets/intl-disneyland.png", alt: "Paris - Disneyland" },
  { img: "/assets/intl-vatican.png", alt: "Roma - Muzeele Vaticane" },
  { img: "/assets/intl-prado.png", alt: "Madrid - Muzeul Prado" },
  { img: "/assets/intl-paris.png", alt: "Paris - Arcul de Triumf" },
];

export const PROMO_SLIDES = [
  { img: "/assets/slide-ro.jpg", imgMobile: "/assets/slide-ro-m.jpg", link: "https://edpi.short.gy/turkish", alt: "Turkish Airlines" },
  { img: "/assets/slide-pleso.png", imgMobile: "/assets/slide-pleso-m.png", link: "https://isic.short.gy/pleso", alt: "Pleso" },
];
